import React from 'react';
import { useTranslation } from 'react-i18next';
import { MapPin, Phone, Mail, Globe, Instagram, Facebook } from 'lucide-react';
import { mockBreeders } from '../utils/mockData';

const Breeders = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-center mb-4 text-gray-900">
            {t('breeders.title')}
          </h1>
          <p className="text-center text-xl text-gray-600 mb-12">
            {t('breeders.subtitle')}
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {mockBreeders.map((breeder) => (
              <div
                key={breeder.id}
                className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-red-500"
              >
                <div className="mb-4">
                  <h3 className="text-xl font-bold text-gray-900 mb-1">{breeder.name}</h3>
                  <p className="text-lg text-red-600 font-semibold">{breeder.fciName}</p>
                  {breeder.registrationNo && (
                    <p className="text-sm text-gray-600 mt-1">Kayıt No: {breeder.registrationNo}</p>
                  )}
                </div>

                <div className="space-y-3">
                  <div className="flex items-center space-x-3 text-gray-700">
                    <MapPin size={20} className="text-red-600 flex-shrink-0" />
                    <span>{breeder.city}</span>
                  </div>

                  <div className="flex items-center space-x-3 text-gray-700">
                    <Phone size={20} className="text-red-600 flex-shrink-0" />
                    <a href={`tel:${breeder.phone.replace(/\s/g, '')}`} className="hover:text-red-600">
                      {breeder.phone}
                    </a>
                  </div>

                  {breeder.email && (
                    <div className="flex items-center space-x-3 text-gray-700">
                      <Mail size={20} className="text-red-600 flex-shrink-0" />
                      <a href={`mailto:${breeder.email}`} className="hover:text-red-600 break-all">
                        {breeder.email}
                      </a>
                    </div>
                  )}

                  {breeder.website && (
                    <div className="flex items-center space-x-3 text-gray-700">
                      <Globe size={20} className="text-red-600 flex-shrink-0" />
                      <a
                        href={`https://${breeder.website}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-red-600 hover:text-red-700 hover:underline"
                      >
                        {breeder.website}
                      </a>
                    </div>
                  )}

                  {(breeder.instagram || breeder.facebook) && (
                    <div className="flex items-center space-x-4 pt-4 border-t border-gray-200">
                      {breeder.instagram && (
                        <a
                          href={breeder.instagram.startsWith('http') ? breeder.instagram : `https://instagram.com/${breeder.instagram.replace('@', '')}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex items-center space-x-2 text-gray-700 hover:text-red-600 transition-colors"
                          aria-label="Instagram"
                        >
                          <Instagram size={20} />
                          <span className="text-sm">{breeder.instagram}</span>
                        </a>
                      )}
                      {breeder.facebook && (
                        <a
                          href={breeder.facebook.startsWith('http') ? breeder.facebook : `https://facebook.com/${breeder.facebook}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex items-center space-x-2 text-gray-700 hover:text-red-600 transition-colors"
                          aria-label="Facebook"
                        >
                          <Facebook size={20} />
                          <span className="text-sm">Facebook</span>
                        </a>
                      )}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Breeders;
